import * as React from 'react';
import { Link } from 'react-router-dom';
import { Log, Order } from './iMonCompte';
import { renderFilArianne, renderDateCommande, renderTitleH1 } from './RenderCommon';
import { getBoutiqueColor, getUserId, sessionExpire } from './MonCompteAction';
import { formatNumCommande, replaceHexadecimalCharacter } from './OrderAction';
import axios from 'axios';
import {getHostApi, getRequestConfig, initEvent} from '../../utils';
import Icons from './Icons';

interface RenderOrderChronologyState {
  orderId: string;
  numCommande: string;
  order?: Order;
}

export default class RenderOrderChronology extends React.Component<any, RenderOrderChronologyState> {
  constructor(params: any) {
    super(params);
    this.state = {
      orderId: this.props.match.params.id,
      numCommande: '',
    };
  }

  componentWillMount() {
    this._getOrder();
  }

  _getOrder = () => {
    document.dispatchEvent(initEvent('dp-loading'));
    axios.get(`${getHostApi()}/customers/${getUserId()}/orders/${this.props.match.params.id}`, getRequestConfig())
      .then((response) => {
      if (response.data.order) {
        this.setState({
          numCommande: response.data.order.numCommande,
          order: response.data.order,
        });
        document.dispatchEvent(initEvent('dp-loaded'));
      }
    }).catch((error) => {
      document.dispatchEvent(initEvent('dp-loaded'));
      if (error.response.status === 401) {
        sessionExpire();
      }
    });
  }

  render() {
    const defineClassLevel = (level: number) => {
      if (level == 100) {
        return 'level';
      }
    };

    const renderLog = (log: Log, i: number) => {
      let bgColor = '';

      if (i === 0) {
        bgColor = getBoutiqueColor();
      }

      return (
        <div key={log.idHistoriqueClients}
             className={'d-flex align-items-center row-chronologie ' + defineClassLevel(log.level)}>
          <div className="col-lg-3 position-relative pr-4 p-3">
            <span className="bold black">{renderDateCommande(this.state.numCommande, log.DateHeure, 'Le')}</span>
            <span className="rounded-circle position-absolute pastilleEtape" style={{ background: bgColor }}>&nbsp;</span>
          </div>
          <div className="pl-4 p-3 col-lg-9">
            <span>
              {log.level == 90 &&
              <Icons icon="warning" size={16} color="orange" className="mr-2"/>
              }
              {replaceHexadecimalCharacter(log.Commentaire)}
            </span>
          </div>
        </div>
      );
    };

    const renderLogs = () => {
      const result = [];
      let i = 0;
      for (const log of this.state.order?.logs || []) {
        if (log.droits == 0) {
          result.push(renderLog(log, i));
          i++;
        }
      }

      return result;
    };

    const renderChronology = () => {
      if (this.state.order) {
        return (
          <div className="chronology">
              <div className="big text-right">
                <Link className="black text-right" to={`/orders/` + this.state.orderId}>
                  <Icons icon="keyboard_arrow_right" size={24} style={{ transform: 'rotate(-180deg)' }} color="black"
                         title="Annuler la réclamation" />
                  Retour
                </Link>
              </div>
            {renderLogs()}
          </div>
        );
      }
    };

    return (
      <div>
        {renderTitleH1('history', 'Suivi de ma commande n°' + formatNumCommande(this.state.numCommande))}
        {renderFilArianne(<Link className="grey" to={`/orders`}>Mes commandes</Link>, 'Suivi de ma commande')}
        {renderChronology()}
      </div>
    );
  }
}
